import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Backend} from "@generated-backend-types";
import {DndDropEvent, DndModule} from "ngx-drag-drop";
import {ContextMenuComponent, ContextMenuModule} from "@perfectmemory/ngx-contextmenu";
import {ContextMenuActionEnum} from "../ContextMenuAction.enum";
import {BehaviorSubject} from "rxjs";
import Attachment = Backend.App.Http.Resources.Dashboard.Attachment;
import {CoreModule} from "../../../../core.module";

@Component({
    selector: 'app-folder[attachment][currentPath][attachmentsByPath]',
    templateUrl: './folder.component.html',
    imports: [CoreModule, ContextMenuModule, DndModule],
    standalone: true
})
export class FolderComponent {

  @ViewChild('folderContextMenu') public folderContextMenu?: ContextMenuComponent<Attachment>;

  @Input() public attachment!: Attachment;
  @Input() public currentDragAttachment?: Attachment;
  @Input() public attachmentsByPath!: BehaviorSubject<{ [key: string]: Attachment[] }>;
  @Input() public currentPath!: BehaviorSubject<string>;

  @Output() public clicked: EventEmitter<{ $event: MouseEvent, attachment: Attachment }> = new EventEmitter()

  @Output() public newDirectory: EventEmitter<Attachment> = new EventEmitter()
  @Output() public uploadFiles: EventEmitter<Attachment> = new EventEmitter()
  @Output() public refresh: EventEmitter<Attachment> = new EventEmitter()
  @Output() public loadPath: EventEmitter<string> = new EventEmitter()

  @Output() public dndStart: EventEmitter<{ $event: DragEvent, attachment: Attachment }> = new EventEmitter()
  @Output() public dndEnd: EventEmitter<{ $event: DragEvent, attachment: Attachment }> = new EventEmitter()
  @Output() public dndCanceled: EventEmitter<{ $event: DragEvent, attachment: Attachment }> = new EventEmitter()

  @Output() public dndDrop: EventEmitter<{
    $event: DndDropEvent,
    attachment: Attachment,
    path: string
  }> = new EventEmitter()
  @Output() public dndDragover: EventEmitter<{ $event: DragEvent, attachment: Attachment }> = new EventEmitter()
  @Output() public executeContextMenu: EventEmitter<{
    action: ContextMenuActionEnum, event: {
      event: MouseEvent | KeyboardEvent;
      value?: Attachment;
    }
  }> = new EventEmitter()


  public clickedOnFolder(event: MouseEvent, attachment: Attachment) {

    this.loadPath.next(attachment.path)

    this.clicked.emit({$event: event, attachment})
  }

  protected readonly ContextMenuActionEnum = ContextMenuActionEnum;
}
